[
    "corepatterns/dashboards/powerbi",
    "requests/dashboards/resquesterorganizationoverview",
    "requests/dashboards/requestsmanagerorganizationoverview",
    "settings/dashboards/analyticsviewer",
    "maintenance/dashboards/plannerold",
    "maintenance/dashboards/maintenanceorganizationoverview",
    "maintenance/dashboards/technicianorganizationoverview",
    "maintenance/dashboards/maintenanceorganizationoverviewstar",
    "maintenance/dashboards/workmanagerorganizationoverview",
    "maintenance/dashboards/planner",
    "maintenance/dashboards/workmanagerorganizationoverviewstar",
    "integration/dashboards/integratororganizationoverview"
]
